module.exports = __webpack_public_path__ + "static/media/Piercing-nipples-bodyPart.c11b92e7.png";